<template>
	<ion-page>
		<spot-header :title="feName" :canGoHome="false" :canGoBack="true" @pressedGoHome="$router.push('/home')" @pressedGoBack="$router.push('/login')"></spot-header>
		<spot-page-menu v-if="enabledItems.length!=1" :menuItems="enabledItems" :isReady="gettedModules" @selected="actionGoTo"></spot-page-menu>
	</ion-page>
</template>

<style scoped></style>

<script>
import { openToast, settings, writeLog } from "@/plugins/common.js";
import { feName } from "@/plugins/variables.js";
import { IonPage } from '@ionic/vue';
import { defineComponent } from 'vue';
import SpotHeader from "@/components/SpotHeader.vue";
import SpotPageMenu from "@/components/SpotPageMenu.vue";

export default defineComponent({
	name: "HomePage",
	components: {
		IonPage,
		SpotHeader,
		SpotPageMenu,
	},
	data: () => ({
		menuItem: {
			picking: 0,
			shipping: 1,
			receipt: 2,
			//storeSupply: 3,
			createSupply: 3,
			fulfillSupply: 4,
			//listInventory: 5,
			printLabel: 5,
			inventory: 6,
			},
		menuItems: [
			//{ id: 0, name: 'Picking', text: 'LISTE DI PRELIEVO', link: "/picking/selection", icon: "swapHorizontal", enabled: null },
			{ id: 0, name: 'Picking', text: 'PRELIEVO DA MAGAZZINO', link: "/picking/selection", icon: "swapHorizontal", enabled: null },
			{ id: 1, name: 'Shipping', text: 'USCITA MERCE', link: "/order/advanced/selection" + "?incoming=false&outgoing=true&picking=false", icon: "logOut", enabled: null },
			{ id: 2, name: 'Receipt', text: 'INGRESSO MERCE', link: "/order/advanced/selection" + "?incoming=true&outgoing=false&picking=false", icon: "logIn", enabled: null },
			//{ id: 3, name: 'StoreSupply', text: 'APPROVVIGIONAMENTO NEGOZIO', link: "/store/selection" + "?picking=true", icon: "cart", enabled: null },
			{ id: 3, name: 'CreateSupply', text: 'APPROVVIGIONAMENTO NEGOZIO', link: "/store/selection" + "?picking=false", icon: "cart", enabled: null },
			{ id: 4, name: 'FulfillSupply', text: 'PRELIEVO PER NEGOZIO', link: "/store/selection" + "?picking=true", icon: "gitPullRequest", enabled: null },
			//{ id: 5, name: 'ListInventory', text: 'INVENTARIO SENZA LISTA', link: "/inventory/selection" + "?free=true&search=true", icon: "clipboard", enabled: null }, //"?free=false"
			{ id: 5, name: 'PrintLabel', text: 'STAMPA CARTELLINO', link: "/print/price_label", icon: "print", enabled: null },
			{ id: 6, name: 'Inventory', text: 'INVENTARIO', link: "/inventory/selection" + "?free=true&picking=true&search=false", icon: "clipboard", enabled: null }, // link is set by getInventoryLink()
			],
		enabledItems: [],
		gettedModules: false,
		feName,
		settings,
		openToast,
		writeLog,
	}),
	computed: {
		pickingItem() { return this.menuItems[this.menuItem.picking] },
		shippingItem() { return this.menuItems[this.menuItem.shipping] },
		receiptItem() { return this.menuItems[this.menuItem.receipt] },
		// storeSupplyItem() { return this.menuItems[this.menuItem.storeSupply] },
		createSupplyItem() { return this.menuItems[this.menuItem.createSupply] },
		fulfillSupplyItem() { return this.menuItems[this.menuItem.fulfillSupply] },
		//listInventoryItem() { return this.menuItems[this.menuItem.listInventory] },
		printLabelItem() { return this.menuItems[this.menuItem.printLabel] },
		inventoryItem() { return this.menuItems[this.menuItem.inventory] },
	},
	async ionViewWillEnter() {
		await this.getAvailableModules();
		if (this.enabledItems.length==1) this.$router.push(this.enabledItems[0].link);
	},
	ionViewWillLeave() {
		this.gettedModules = false;
		// Do Nothing
	},
	methods: {
		// Settings & StartUp
		async getAvailableModules() {
			this.gettedModules = false;
			this.enabledItems = [];
			await this.getSettingParams();
			await this.fillAvailableItems();
			this.gettedModules = true;
		},
		async getSettingParams() {
			await this.getData("info/settings")
			.then((data) => {
				if (data && data.track) {
					this.settings.enablePickingList = (!data.track.enable_picking_list) ? false : (data.track.enable_picking_list == 0 ? false : true);
					this.settings.enableShipping = (!data.track.enable_shipping) ? false : (data.track.enable_shipping == 0 ? false : true);
					this.settings.enableReceipt = (!data.track.enable_receipt) ? false : (data.track.enable_receipt == 0 ? false : true);
					this.settings.enableMovement = (!data.track.enable_movement) ? false : (data.track.enable_movement == 0 ? false : true);
					this.settings.enableInventory = (!data.track.enable_inventory) ? false : (data.track.enable_inventory == 0 ? false : true);
					this.settings.manageGs1Ai = (!data.track.manage_gs1_ai) ? false : (data.track.manage_gs1_ai == 0 ? false : true);
					this.settings.fullInventory = (!data.track.full_inventory) ? false : (data.track.full_inventory == 0 ? false : true);
				}
			}).catch((error) => {
				this.openToast(error, "warning");
			});
		},
		async fillAvailableItems() {
			if (this.settings.enablePickingList == true) this.enabledItems.push(this.pickingItem);
			if (this.settings.enableShipping == true) this.enabledItems.push(this.shippingItem);
			if (this.settings.enableReceipt == true) this.enabledItems.push(this.receiptItem);
			if (this.settings.enableMovement == true) this.enabledItems.push(this.createSupplyItem);
			if (this.settings.enableMovement == true) this.enabledItems.push(this.fulfillSupplyItem);
			if (this.settings.printerManagement == true) this.enabledItems.push(this.printLabelItem);
			//if (this.settings.enableInventory == true) this.enabledItems.push(this.listInventoryItem);
			this.inventoryItem.link = this.getInventoryLink();
			if (this.settings.enableInventory == true) this.enabledItems.push(this.inventoryItem);
			// this.gettedModules = true;
		},
		getInventoryLink() { // fullInventory: true = Inventory with list (ManageListInventory); false = Mixed Inventory (ManageMixedInventory)
			return (this.settings.fullInventory == true) ? "/inventory/selection" + "?free=false&search=true" : "/inventory/selection" + "?free=true&picking=true&search=false";
		},
		// Database
		async getData(tableName) {
			let data = await this.$store.dispatch("tables/getInfoSettings", tableName )
			return data;
		},
		// Actions
		actionGoTo(target) {
			this.writeLog(target);
			switch (target.id) {
				case this.pickingItem.id:
					//this.$router.push("/order/advanced/selection" + "?incoming=false&outgoing=false&picking=true");
					this.$router.push("/picking/selection");
					break;
					case this.shippingItem.id:
					this.$router.push("/order/advanced/selection" + "?incoming=false&outgoing=true&picking=false");
					break;
				case this.receiptItem.id:
					this.$router.push("/order/advanced/selection" + "?incoming=true&outgoing=false&picking=false");
					break;
				/*
				case this.storeSupplyItem.id:
					this.$router.push("/store/selection");
					break;
				*/
				case this.createSupplyItem.id:
					this.$router.push("/store/selection" + "?picking=false");
					break;
				case this.fulfillSupplyItem.id:
					this.$router.push("/store/selection" + "?picking=true");
					break;
				case this.printLabelItem.id:
					this.$router.push("/print/price_label");
					break;
				//case this.listInventoryItem.id:
				case this.inventoryItem.id:
					this.$router.push(this.getInventoryLink());
					break;
			}
		}
	}
});
</script>
